var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartnerIconSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2H10V1.5C9.99835 1.10268 9.83979 0.722106 9.55884 0.441158C9.27789 0.160209 8.89732 0.00164523 8.5 0H5.5C5.10268 0.00164523 4.72211 0.160209 4.44116 0.441158C4.16021 0.722106 4.00165 1.10268 4 1.5V2H1.5C1.23478 2 0.98043 2.10536 0.792893 2.29289C0.605357 2.48043 0.5 2.73478 0.5 3V11C0.5 11.2652 0.605357 11.5196 0.792893 11.7071C0.98043 11.8946 1.23478 12 1.5 12H12.5C12.7652 12 13.0196 11.8946 13.2071 11.7071C13.3946 11.5196 13.5 11.2652 13.5 11V3C13.5 2.73478 13.3946 2.48043 13.2071 2.29289C13.0196 2.10536 12.7652 2 12.5 2V2ZM5 1.5C5 1.36739 5.05268 1.24021 5.14645 1.14645C5.24021 1.05268 5.36739 1 5.5 1H8.5C8.63261 1 8.75979 1.05268 8.85355 1.14645C8.94732 1.24021 9 1.36739 9 1.5V2H5V1.5ZM12.5 3V5.6C10.8128 6.51983 8.92164 7.00122 7 7C5.07836 7.00122 3.18719 6.51983 1.5 5.6V3H12.5ZM5.75 5.5C5.75 5.36739 5.80268 5.24021 5.89645 5.14645C5.99021 5.05268 6.11739 5 6.25 5H7.75C7.88261 5 8.00979 5.05268 8.10355 5.14645C8.19732 5.24021 8.25 5.36739 8.25 5.5C8.25 5.63261 8.19732 5.75979 8.10355 5.85355C8.00979 5.94732 7.88261 6 7.75 6H6.25C6.11739 6 5.99021 5.94732 5.89645 5.85355C5.80268 5.75979 5.75 5.63261 5.75 5.5Z",
    fill: "#1C86F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerIconSmall);
export default __webpack_public_path__ + "static/media/partnerIconSmall.bc1fd92738df50a9e75943297985903f.svg";
export { ForwardRef as ReactComponent };